import { FC } from 'react'

import LoadingButton from '@/components/loading-button'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog'
import { Button } from '@/components/ui/button'
import { Invitation } from '@/out/invitation'

import useRevokeInvitation from './useRevokeInvitation'

type Props = {
  invitation: Invitation
  onRevoke: (id: string) => void
}

const RevokeInvitationDialog: FC<Props> = ({ invitation, onRevoke }) => {
  const [revoke, { timer }] = useRevokeInvitation(onRevoke)

  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <Button
          data-testid="revoke-invitation-button"
          variant="secondary"
          size="sm"
          className="hover:bg-destructive hover:text-background"
        >
          Revoke Invitation
        </Button>
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure?</AlertDialogTitle>
          <AlertDialogDescription>
            After revoking the invitation, the user will need to be invited again if you wish to give them access.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="revoke-invitation-button-cancel">Cancel</AlertDialogCancel>
          <LoadingButton
            data-testid="revoke-invitation-button-confirm"
            timer={timer}
            variant="destructive"
            onClick={() => revoke(invitation)}
          >
            Revoke Invitation
          </LoadingButton>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}

export default RevokeInvitationDialog
